import {createReducer} from '@reduxjs/toolkit';
import {getAllEventsSuccess} from 'src/openapi/apis/EventControllerApi';
import {EventBasicInfo} from 'src/openapi/models/EventBasicInfo';

import {cleanEventsInfo} from './actions';

type State = {
    data: Array<EventBasicInfo>,
};

const defaultState = {
    data: [],
};

export const eventsInfo = createReducer<State>(defaultState, builder => builder
    .addCase(getAllEventsSuccess, (state, action) => {
        state.data = action.payload.data;
    })
    .addCase(cleanEventsInfo, state => {
        state.data = [];
    }),
);
